import contactBg from '../../../assets/imgs/contact.jpeg'

export default function ContactHeader() {
    return (
        <div className="contact-header">
            <div className="contact-header-bg">
                <img src={contactBg} alt='Pixad Contact'/>
            </div>

            <div className="contact-header-wrapper">
                <h2 className="contact-title">Get in touch</h2>
                <p className="contact-desc">Contact us, we're happy to assist you any time!</p>
            </div>
        </div>
    )
}